"use client";

import { useEffect, useState } from "react";
import { useSession } from "next-auth/react";
import { apiGet } from "@/lib/api";

interface UploadEligibility {
  isVerified: boolean;
  isApproved: boolean;
  canUploadSfw: boolean;
  canUploadExplicit: boolean;
}

const DEFAULT: UploadEligibility = {
  isVerified: false,
  isApproved: false,
  canUploadSfw: false,
  canUploadExplicit: false,
};

export function useUploadEligibility() {
  const { data: session, status } = useSession();
  const [eligibility, setEligibility] = useState<UploadEligibility>(DEFAULT);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (status !== "authenticated") {
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const data = await apiGet<UploadEligibility>(
          "/api/profile/upload-eligibility",
          session
        );
        if (!cancelled) setEligibility(data);
      } catch {
        // Fail silently — default to most restrictive
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [status, session]);

  return { ...eligibility, loading };
}
